const d = (n, e, i) => typeof i > "u" ? n[e] != null : n[e] === i;
export {
  d as i
};
